import { useMemo } from 'react';
import { SimpleGrid } from '@chakra-ui/react';
import { DayType } from './type';

import dayListGenerator from './utils/dayListGenerator';

import Day from './Day';

type CalendarProps = {
  controlDate: Date;
  dayRuleFn: (date: Date) => DayType;
  onChangeDate: (date: Date) => void;
};

export default function Calendar({ controlDate, onChangeDate, dayRuleFn }: CalendarProps) {
  const dayList = useMemo(() => {
    return dayListGenerator(
      { year: controlDate.getFullYear(), month: controlDate.getMonth() },
      dayRuleFn,
    );
  }, [controlDate, dayRuleFn]);

  return (
    <SimpleGrid columns={7} gap={1}>
      {dayList.map((dayObj) => {
        return <Day {...dayObj} onChangeDay={onChangeDate} />;
      })}
    </SimpleGrid>
  );
}
